import { extendTheme } from '@chakra-ui/react';
import { ButtonStyle as Button } from './styles/buttonStyle';
import { ContainerStyle as Container } from './styles/containerStyle';
import { BadgeStyle as Badge } from './styles/badgeStyle';
// 차크라 커스텀 테마
const theme = extendTheme({
  colors: {
    primary: '#6D9775',
    secondary: '#615049',
    backgroundColor: '#F1EDE5',
    grayBackground: '#F3F5F7',
  },
  fonts: {
    heading: 'IBM Plex Sans KR',
    body: 'IBM Plex Sans KR',
  },
  styles: {
    global: {
      body: {
        bg: 'backgroundColor',
        color: 'secondary',
      },
    },
  },
  components: {
    Button,
    Container,
    Badge,
  },
});

export default theme;
